<template>
  <div>
    <CContainer class="mb-4">
      <CRow>
        <CCol md="3">
          <CButton 
            :disabled="banners.length >= 5" 
            class="w-100" 
            color="success" 
            @click="() => { modalVisible.insert = true }"
          >
            <div class="button-text">
              <CIcon name="cil-plus" />
              <span>New</span>
            </div>
          </CButton>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Loader -->
    <CContainer class="d-flex justify-content-center" v-if="isLoad">
      <CSpinner color="primary" size="lg"/>
    </CContainer>
    <CContainer v-else>
      <CRow v-if="banners.length">
        <CCol 
          :sm="12" 
          v-for="banner in banners" 
          :key="banner.id"
        >
          <CCard>
            <CCardBody>
              <CRow class="mb-5">
                <CCol sm="6">
                  <h5 class="mb-3">Desktop Image</h5>
                  <img
                    alt="Desktop Image" 
                    draggable="false"
                    :src="banner.dImgUrl"
                    class="w-100"
                  />
                </CCol>
                <CCol sm="6">
                  <h5 class="mb-3">Mobile Image</h5>
                  <img
                    alt="Mobile Image" 
                    draggable="false"
                    :src="banner.mImgUrl"
                    class="w-100"
                  />
                </CCol>
              </CRow>
              <CRow v-if="banner.redirectUrl.length">
                <CCol sm="12">
                  <h5 class="mb-3">Redirect URL</h5>
                  <p class="text-muted">{{ banner.redirectUrl }}</p>
                </CCol>
              </CRow>
            </CCardBody>
            <CCardFooter>
              <CButton color="danger" variant="ghost" @click="() => { 
                modalVisible.delete = true 
                id = banner.id
              }">
                <div class="button-text">
                  <CIcon name="cil-trash" />
                  <span>Delete</span>
                </div>
              </CButton>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Modal -->
    <CModal
      :show.sync="modalVisible.insert"
      :closeOnBackdrop="false"
      :centered="true"
      size="xl"
    >
      <CRow md="12">
        <CCol md="6">
          <div class="mb-3">
            <h6>Desktop Image</h6>
            <image-uploader
              v-model="dBanner"
              :maxSize="4"
              ref="iuDesktop" 
              :isEdit="true"
              class="mb-3"
            />
            <CAlert class="mt-4" color="warning">
              <ul class="mb-0">
                <li>Aspect ratio: 16:9</li>
                <li>Max image size: 4Mb</li>
              </ul>  
            </CAlert>
          </div>
        </CCol>
        <CCol md="6">
          <h6>Mobile Image</h6>
          <image-uploader
            v-model="mBanner"
            :maxSize="4"
            ref="iuMobile" 
            :isEdit="true"
            class="mb-3"
          />
          <CAlert class="mt-4" color="warning">
            <ul class="mb-0">
              <li>Aspect ratio: 4:5</li>
              <li>Max image size: 4Mb</li>
            </ul>  
          </CAlert>
        </CCol>
        <CCol md="12">
          <CInput
            label="Redirect URL"
            placeholder="e.g. https://google.com/"
            v-model="redirectUrl"
          />
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Insert Banner</h5>
        <CButtonClose @click="dismissModal" class="text-black"/>
      </template>
      <template #footer>
        <CButton @click="handleInsert" color="primary">Save</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
    <CModal
      title="Modal title"
      color="danger"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="modalVisible.delete"
    >
      Are you sure you want to delete this item ?
      <template #header>
        <h5 class="modal-title">Delete Banner</h5>
        <CButtonClose @click="dismissModal" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="handleDelete(id)" color="danger">OK</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { 
  CONFIG_GET, 
  CONFIG_UPDATE,
  BANNER_DELETE,
} from '../../../constants/api'

import axios from 'axios'

import ImageUploader from '../../components/ImageUploader'

export default {
  components: { ImageUploader },

  data () {
    return {
      id: '',
      banners: [],
      redirectUrl: '',
      modalVisible: {
        insert: false,
        delete: false,
      },
      isLoad: false,
      accessToken: sessionStorage.getItem('access_token') || '',
      dBanner: '',
      mBanner: ''
    }
  },

  beforeMount () {
    this.fetchConfig()
  },

  methods: {
    fetchConfig () {
      this.isLoad = true

      axios.get(`${CONFIG_GET}/home_banner_options`, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(res => {
          this.banners = res.data.data
          this.isLoad = false
          this.dismissModal()
        })
    }, 

    handleInsert () {
      const payload = {
        newConfig: JSON.stringify({ 
          redirectUrl: this.redirectUrl || '',
          dImgUrl: this.dBanner,
          mImgUrl: this.mBanner, 
        }),
      }
      axios.put(`${CONFIG_UPDATE}/home_banner_options`, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchConfig())
    },

    handleDelete (id) {
      axios.delete(`${BANNER_DELETE}/${id}`, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchConfig())
    },

    dismissModal () {
      this.id = ''
      this.redirectUrl = ''
      this.modalVisible.delete = false
      this.modalVisible.insert = false
      this.mBanner = ''
      this.dBanner = ''
    },
  }  
}
</script>

<style scoped>
  .button-text {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .button-text > span {
    margin-left: 6px;
  }
</style>